
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/blogs/2025-04-05-supabase-declarative-schemas-review",
      function () {
        return require("private-next-pages/blogs/2025-04-05-supabase-declarative-schemas-review/index.page.mdx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/blogs/2025-04-05-supabase-declarative-schemas-review"])
      });
    }
  